module.exports = __webpack_public_path__ + "static/media/gcdef_10011.19288663.ico";